import { render, staticRenderFns } from "./UpdateBlock.vue?vue&type=template&id=8094b4ee&scoped=true"
import script from "./UpdateBlock.vue?vue&type=script&lang=js"
export * from "./UpdateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8094b4ee",
  null
  
)

export default component.exports